import { render, staticRenderFns } from "./VolunteergiftsRecordDetail.vue?vue&type=template&id=1d39ed1c&scoped=true"
import script from "./VolunteergiftsRecordDetail.vue?vue&type=script&lang=js"
export * from "./VolunteergiftsRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./VolunteergiftsRecordDetail.vue?vue&type=style&index=0&id=1d39ed1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39ed1c",
  null
  
)

export default component.exports